import { createContext } from 'react';

type LicenseState = {
  currentLicenseKey: string | undefined;
  daysUntilLicenseExpires: number | undefined;
  isLicenseExpired: boolean;
  isLicenseAboutExpiredModal: boolean;
};

type LicenseActions = {
  updateLicenseData: (
    currentLicenseKey: string,
    daysUntilLicenseExpires: number,
    isLicenseExpired: boolean
  ) => void;
  setLicenseExpired: (currentLicenseKey: string, isLicenseExpired: boolean) => void;
  resetLicenseAboutExpiredModal: () => void;
};

export type LicenseContextType = LicenseState & LicenseActions;

const initialState: LicenseContextType = {
  currentLicenseKey: undefined,
  daysUntilLicenseExpires: undefined,
  isLicenseExpired: false,
  isLicenseAboutExpiredModal: false,
  updateLicenseData: () => {},
  setLicenseExpired: () => {},
  resetLicenseAboutExpiredModal: () => {}
};

export const LicenseContext = createContext<LicenseContextType>(initialState);
